"use client";

import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/forms/Button";
import { Tooltip } from "@/components/common/ui/Tooltip";

interface ReportButtonProps {
  /** Button size variant */
  size?: "sm" | "md";
  /** Button label — defaults to "Report a Problem" */
  label?: string;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  /** Disable the button (keeps it visible) */
  disabled?: boolean;
  /** Tooltip shown on hover when disabled */
  disabledTooltip?: string;
}

export function ReportButton({
  size = "md",
  label = "Report a Problem",
  onClick,
  className = "",
  disabled = false,
  disabledTooltip,
}: ReportButtonProps) {
  const button = (
    <Button
      variant="warning"
      size="responsive"
      onClick={disabled ? undefined : onClick}
      className={className}
      startIcon={<AlertTriangle className="w-4 h-4" />}
      disabled={disabled}

    >
      {label}
    </Button>
  );

  if (disabled && disabledTooltip) {
    return (
      <Tooltip content={disabledTooltip} placement="top">
        <span>{button}</span>
      </Tooltip>
    );
  }

  return button;
}
